import React, { createRef, useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './CopyToClipboardButton.styles'
import { Button, Icon } from '../../atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'

/**
 * functional container for all detail views
 * @returns {*}
 * @constructor
 */
const CopyToClipboardButton = ({
  label,
  contentToCopy = '',
  className = '',
  ...rest
}) => {
  const textContext = useContext(TextContext)
  const [enabled, setEnabled] = useState(true)
  const inputToCopyRef = createRef()
  const timer = React.useRef(null)

  /**
   * clean up on component destroy
   */
  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    },
    [timer]
  )

  const clickHandler = () => {
    if (!enabled) return

    try {
      setEnabled(false)
      inputToCopyRef.current.select()
      document.execCommand('copy')
      inputToCopyRef.current.blur()

      if (timer.current) {
        clearTimeout(timer.current)
      }
      timer.current = setTimeout(() => {
        setEnabled(true)
      }, 2000)
    } catch (err) {
      if (console) {
        console.error('unable to copy:', err)
      }
    }
  }

  const getLabel = () => {
    if (!enabled) return textContext['copyToClipboard.button.label.copied']

    return label ? label : textContext['copyToClipboard.button.label']
  }

  return (
    <Styled.CopyToClipboardComponent enabled={ enabled } { ...rest }>
      <input
        ref={ inputToCopyRef }
        value={ contentToCopy }
        readOnly
        className={ 'input-to-copy' }
        type='text'
      />
      <Button
        icon={ <Icon className='icon-f-printer-dark' /> }
        onClick={ clickHandler }
        className={ `btn-copy-to-clipboard btn-link ${ className }` }
        text={ getLabel() }
      />
    </Styled.CopyToClipboardComponent>
  )
}

CopyToClipboardButton.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  contentToCopy: PropTypes.string,
}

export default CopyToClipboardButton
